import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { SystemPopup } from '@gongxigames/framework/slot/types';
import { MultiSetsMulticampaignPromotionModule, MultiSetsMulticampaignPromotionModuleEvents } from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionEndState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents
> {
    private endPopup!: SystemPopup;

    public onEnterState(): void {
        const promotiondata = this.module.getPromotion().getData();
        const settingsPrefix = promotiondata.type === 'free-round' ? 'freeRounds' : 'awardedFeature';
        const regulationSettings = {
            valuedAtEnabled: this.module.settings.get(`${settingsPrefix}ValuedAtEnabled`),
            expiresInEnabled: this.module.settings.get(`${settingsPrefix}ExpiresInEnabled`),
            optOutEnabled: this.module.settings.get(`${settingsPrefix}OptOutEnabled`) && !promotiondata.isInUse,
            playLaterEnabled: this.module.settings.get(`${settingsPrefix}PlayLaterEnabled`),
            youHaveWonEnabled: this.module.settings.get(`${settingsPrefix}YouWonEnabled`)
        };

        this.endPopup = this.module.popups.createMultiSetsMulticampaignPromotionEndPopup({
            ...promotiondata,
            onClickOk: this.onClickOk.bind(this),
            regulationSettings,
        });

        this.module.showPopup(this.endPopup);
    }

    private onClickOk(): void {
        this.module.hidePopup(this.endPopup);
        this.module.endPromotion();
    }

    public onLeaveState(): void {
        this.emit('General.Slot.SPIN.ENABLE', MultiSetsMulticampaignPromotionModule.NAME);
    }

    protected setupEvents(): void {}
}
